var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramGreenLoan48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-64.000000, -95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pictogram/Greenloan",
    transform: "translate(64.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram",
    transform: "translate(2.250000, 7.500000)",
    stroke: "#4F4C4D",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "tree",
    transform: "translate(0.278313, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.971686747,10.499814 C0.971686747,16.2989351 5.67275165,21 11.4718728,21 C17.2706218,21 21.9716867,16.2989351 21.9716867,10.499814 C21.9716867,4.7010649 17.2706218,0 11.4718728,0 C5.67275165,0 0.971686747,4.7010649 0.971686747,10.499814 Z",
    id: "Stroke-70",
    fill: "#00AA00"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.4716867,
    y1: 10.5,
    x2: 11.4716867,
    y2: 32.5,
    id: "Stroke-74"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-76",
    points: "14.9716867 14 11.4714978 18 7.97168675 14"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.75,7.45287398 L40,16.2693633 L40,31.75 L17.5,31.75 L17.5,16.2693633 L28.75,7.45287398 Z",
    id: "Home",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Focus",
    points: "35.75 22.5 30.75 22.5 30.75 17.5 35.75 17.5"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramGreenLoan48);
export default __webpack_public_path__ + "static/media/pictogramGreenLoan48.b1d490baff12372d7194b33370fdd171.svg";
export { ForwardRef as ReactComponent };